// extracted by mini-css-extract-plugin
export default {"cardNumber":"LibraryLessonCardNumber_cardNumber__ruLCY"};